"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateLocationBodyToJSON = exports.ActivateLocationBodyFromJSONTyped = exports.ActivateLocationBodyFromJSON = void 0;
function ActivateLocationBodyFromJSON(json) {
    return ActivateLocationBodyFromJSONTyped(json, false);
}
exports.ActivateLocationBodyFromJSON = ActivateLocationBodyFromJSON;
function ActivateLocationBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
    };
}
exports.ActivateLocationBodyFromJSONTyped = ActivateLocationBodyFromJSONTyped;
function ActivateLocationBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
    };
}
exports.ActivateLocationBodyToJSON = ActivateLocationBodyToJSON;
